import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { addRiskRegister, deleteFileChat, saveOnChange, saveQuestion, showDetailsvendorQuestioner, uploadImageInChat, uploadEvidence, deleteEvidence } from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import uploadDoc from "../../assets/images/upload-doc.png";
import moment from "moment";
import sendButtonImg from "../../assets/images/send-chat-button.png";
import { toastr } from "react-redux-toastr";
import { useWebSocket } from '../WebSocket/useWebSocket';
import axios from "axios";
import { API_URL } from "../../utils/constant";

const ShowDetailsVendorQuestionnaires = () => {
    const { _id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const id = useSelector((state) => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });
    const [isModal, setModal] = useState("");
    const [isModalData, setModalData] = useState([]);
    const [autoFillData, setAutoFillData] = useState(null);
    const [page, setPage] = useState(() => {
        // Get page from URL query parameter or default to 1
        const searchParams = new URLSearchParams(window.location.search);
        return parseInt(searchParams.get('page')) || 1;
    });
    const [totalItems, setTotalItems] = useState(1);
    const [textarea, setTextArea] = useState("");
    const [comment, setComment] = useState("");
    const [input, setInput] = useState("");
    const [draft, setDraft] = useState();
    const [data, setData] = useState([]);
    const showDetails = useSelector((state) => state?.riskManagement?.showDetailsvendorQuestionnaire?.data?.questionForm);
    const formStatus = useSelector((state) => state?.riskManagement?.showDetailsvendorQuestionnaire?.data);
    const totalQuestion = useSelector((state) => state?.riskManagement?.showDetailsvendorQuestionnaire?.data);
    const [selectedOptions, setSelectedOptions] = useState({})
    const [messageInput, setMessageInput] = useState(''); // Input for new me
    const session = localStorage.getItem("session");
    const [registerFor, setRegisterFor] = useState("forever");
    const [riskLevel, setRiskLevel] = useState("low");
    const [questionId, setQuestionId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [riskNote, setRiskNote] = useState("");
    const [chatData, setChatData] = useState([]);
    const { chatId } = useParams();
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [assigneeOrganisationId, setAssigneeOrganisationId] = useState("");
    const [fileSent, setFileSent] = useState("");
    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const [aiLoading, setAiLoading] = useState(false);
    const [savingState, setSavingState] = useState({});
    const {
        connectionStatus,
        messageAll,
        messageSend,
        sendMessage,
        getMessages
    } = useWebSocket({
        userId: _id,
        orgId: id
    });
    const [isChatMinimized, setIsChatMinimized] = useState(false);


    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('files', file);

        uploadImageInChat(formData)
            .then(response => {
                setFileSent(response);
                setSelectedFile(file);
            })
            .catch(error => {
                // console.error removed
            });
    };

    const getQuestionsForAI = () => {
        const questions = [];

        isModalData?.forEach(category => {
            category.categoryQuestions?.forEach(question => {
                const questionData = {
                    question: question.question_text,
                    questionType: ""
                };

                if (question.type === "text") {
                    questionData.questionType = "text";
                } else if (question.type === "multiple_choice_multi_select") {
                    questionData.questionType = "multipleOption";
                    questionData.questionOptions = question.options;
                } else {
                    questionData.questionType = "singleOption";
                    questionData.questionOptions = question.options;
                }

                questions.push({
                    ...questionData,
                    questionId: question.id,
                    categoryId: category.id
                });
            });
        });

        return questions;
    };

    const handleAIQuestionnaireSubmit = async () => {
        try {
            setAiLoading(true);
            const questions = getQuestionsForAI();

            const response = await axios.post(
                `${API_URL}/tprm/${id}/question-forms/${_id}/ai-assistant/answer-questions`,
                { questions: questions.map(({ questionId, categoryId, ...rest }) => rest) }
            );

            if (response.data && !response.data.error) {
                // Refetch the data to get the updated questionnaire with AI responses
                await fetchData();
                
                toastr.success("AI has completed answering questions");
            } else {
                toastr.error("Error getting AI responses");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Failed to get AI responses");
        } finally {
            setAiLoading(false);
            setIsAiModalOpen(false);
        }
    };

    const removeFile = async (q, c, r) => {
        try {
            // Call the new delete evidence API
            await deleteEvidence(id, _id, c, q?.id, {
                key: r.fileKey || r.key,
                fileType: r.fileType,
                fileSize: r.fileSize,
                fileName: r.fileName,
                storageType: r.storageType,
                signedUrl: r.signedUrl
            });

            // After successful deletion, update the local state
            const currentResponse = q?.response || {};
            const currentEvidences = currentResponse.evidences;
            
            // Handle both array and object cases for evidences
            let evidencesArray = [];
            if (Array.isArray(currentEvidences)) {
                evidencesArray = currentEvidences.filter(ev => ev.fileKey !== r.fileKey);
            } else if (currentEvidences && typeof currentEvidences === 'object' && !Array.isArray(currentEvidences)) {
                // If it's a single object, only include it if it's not the one being removed
                if (currentEvidences.fileKey !== r.fileKey) {
                    evidencesArray = [currentEvidences];
                }
            }
            
            let data = {
                categoryId: c,
                questionId: q?.id,
                response: {
                    ...currentResponse,
                    evidences: evidencesArray
                }
            }
            saveOnChange(id, _id, data, dispatch);
            
            // Refresh the data to get updated evidence list
            await fetchData();
            
            toastr.success("File deleted successfully");
        } catch (error) {
            // console.error removed
            toastr.error("Failed to delete file: " + error.message);
        }
    }

    const uploadImg = async (e, q, categoryId) => {
        let questionId = q?.id;
        const currentResponse = q?.response || {};
        const currentEvidences = currentResponse.evidences;
        const files = Array.from(e.target.files || []);

        // Check if number of files exceeds limit
        if (files.length > 5) {
            alert('You can only upload up to 5 images at once');
            return;
        }

        // Check if no files were selected
        if (files.length === 0) return;

        try {
            const formData = new FormData();
            files.forEach(file => {
                formData.append('files', file);
            });

            // Call the new upload evidence API
            const response = await uploadEvidence(id, _id, categoryId, questionId, formData);

            if (response && response.error === false) {
                // Handle both array and object cases for evidences
                let existingEvidences = [];
                if (Array.isArray(currentEvidences)) {
                    existingEvidences = currentEvidences;
                } else if (currentEvidences && typeof currentEvidences === 'object' && !Array.isArray(currentEvidences)) {
                    existingEvidences = [currentEvidences];
                }
                
                // let data = {
                //     categoryId: categoryId,
                //     questionId: questionId,
                //     response: {
                //         ...currentResponse,
                //         evidences: [
                //             ...existingEvidences,
                //             ...response.data.map(item => ({
                //                 fileKey: item.key,
                //                 storageType: item.storageType,
                //                 fileName: item.fileName,
                //                 fileType: item.fileType,
                //                 fileSize: item.fileSize,
                //                 signedUrl: item.signedUrl,
                //                 actionType: "add",
                //             }))
                //         ]
                //     }
                // }
                // saveOnChange(id, _id, data, dispatch);
                
                // Refresh the data to get updated evidence list
                await fetchData();
                
                toastr.success("Files uploaded successfully");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Failed to upload files: " + error.message);
        }
    };

    const sendMessages = () => {
        if (messageInput == "") {
            toastr.error("Please enter the message.");
            return
        }

        sendMessage({
            messageText: messageInput,
            questionFormId: _id,
            questionCategoryId: categoryId,
            questionId: questionId,
            toOrganisationId: assigneeOrganisationId,
            ...(fileSent?.data && {
                attachedFiles: fileSent?.data
            })
        });

        setMessageInput("");
        setFileSent("");
        setSelectedFile("");

        // Set a small timeout to ensure the new message is added to the DOM before scrolling
        setTimeout(() => {
            const chatContainer = document.querySelector('.chatBoxMain');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        }, 300);
    };


    const chatOpenBox = async (categoryName, question, categoryId, event) => {
        // Get the clicked question's container element
        const questionElement = event.target.closest('.question-container');
        const questionRect = questionElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        setCategoryId(categoryId);
        setQuestionId(question?.id);
        setChatData([categoryName, question, categoryId]);
        setIsChatMinimized(false);

        // Increased the offset from 20px to 50px to move the chat panel higher up
        const chatTop = questionRect.top + scrollTop - 0;
        document.documentElement.style.setProperty('--chat-top-position', `${chatTop}px`);

        // Get the messages for this question
        await getMessages({
            organisationId: id,
            questionCategoryId: categoryId,
            questionFormId: _id,
            questionId: question?.id
        });

        // Set a small timeout to ensure the DOM is updated before scrolling
        setTimeout(() => {
            const chatContainer = document.querySelector('.chatBoxMain');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        }, 100);
    };

    const fetchData = useCallback(async () => {
        if (!id || !_id) return;
        
        try {
            // Use the action creator instead of dispatching directly
            showDetailsvendorQuestioner(id, dispatch, _id, page);
            
            // Fetch questionnaire details for local state
            const response = await axios.get(
                `${API_URL}/tprm/${id}/question-forms/${_id}?page=${page}`
            );

            if (response.data && !response.data.error) {
                const questionForm = response.data.data.questionForm;
                if (questionForm && questionForm.form) {
                    // Set local state
                    setModalData(questionForm.form);
                    setTotalItems(response.data.data.totalQuestions);

                    // Update URL with current page
                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.set('page', page);
                    history.replace({
                        pathname: window.location.pathname,
                        search: searchParams.toString()
                    });
                }
            }
        } catch (error) {
            // console.error removed
            toastr.error("Failed to fetch questionnaire details");
        }
    }, [id, _id, page, dispatch, history]);

    useEffect(() => {
        // Only fetch if we have both id and _id
        if (id && _id) {
            fetchData();
        }
    }, [fetchData]);

    useEffect(() => {
        if (chatId) {
            const category = showDetails?.form?.find(cat =>
                cat?.categoryQuestions?.some(question => question?.id === chatId)
            );

            const questionData = category?.categoryQuestions?.find(question =>
                question.id === chatId
            );

            if (category && questionData) {
                getMessages({
                    organisationId: id,
                    questionCategoryId: category?.id,
                    questionFormId: _id,
                    questionId: questionData?.id
                });

                setCategoryId(category?.id);
                setQuestionId(questionData?.id);
                setChatData([category?.categoryName, questionData?.id, category?.id]);
            }
        }
    }, [chatId, showDetails, id, _id]);

    useEffect(() => {
        setAssigneeOrganisationId(showDetails?.assignerOrganisationId)
    }, [showDetails?.assignerOrganisationId])

    useEffect(() => {
        setTotalItems(totalQuestion?.totalQuestions)
    }, [totalQuestion?.totalQuestions])


    useEffect(() => {
        const chatContainer = document.querySelector('.chatBoxMain');
        if (chatContainer && messageAll?.length > 0) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    }, [messageAll]);

    useEffect(() => {
        setModalData(showDetails?.form)
    }, [showDetails?.form]);

    useEffect(() => {
        const initialOptions = {};
        const initialTextValues = new Map();
        const initialComments = {};

        isModalData?.forEach(category => {
            category.categoryQuestions?.forEach(question => {
                if (question.response) {
                    // Handle text responses
                    if (question.type === "text") {
                        initialTextValues.set(question.id, question.response.value);
                    }
                    // Handle options (single/multi-select)
                    else if (question.response.value) {
                        initialOptions[question.id] = Array.isArray(question.response.value)
                            ? question.response.value
                            : [question.response.value];
                    }
                    // Handle comments
                    if (question.response.comment) {
                        initialComments[question.id] = question.response.comment;
                    }
                }
            });
        });

        setSelectedOptions(initialOptions);
        
        // Merge server comments with existing local state to preserve in-progress edits
        setComment(prevComments => {
            const merged = { ...prevComments };
            // Only update comments that don't exist in local state or match the server value
            // This preserves any unsaved changes the user is currently typing
            Object.keys(initialComments).forEach(questionId => {
                // Only update if this comment doesn't exist in local state
                // OR if the local state matches what we're about to set (meaning it was saved)
                if (prevComments[questionId] === undefined || 
                    prevComments[questionId] === initialComments[questionId]) {
                    merged[questionId] = initialComments[questionId];
                }
                // Otherwise, keep the local state (user is actively editing)
            });
            return merged;
        });

        initialTextValues.forEach((value, id) => {
            setTextArea(prevState => ({
                ...prevState,
                [id]: value
            }));
        });
    }, [isModalData]);

    useEffect(() => {
        if (chatData.length > 0) {
            const chatContainer = document.querySelector('.chatBoxMain');
            if (chatContainer && messageAll?.length > 0) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        }
    }, [messageAll, chatData]);

    const SelectInput = (e, question, option, type, categoryId) => {
        const questionId = question?.id;
        const currentResponse = question?.response || {};

        if (type === "text") {
            // Local state is already updated in the onChange handler
            // Set up debounced API call
            if (question.textSaveTimeout) {
                clearTimeout(question.textSaveTimeout);
            }

            question.textSaveTimeout = setTimeout(() => {
                // Send API request with current value (including empty strings for clearing)
                const data = {
                    categoryId: categoryId,
                    questionId: questionId,
                    response: {
                        ...currentResponse,
                        value: e,
                    },
                };
                saveOnChange(id, _id, data, dispatch, page);
            }, 1200); // Wait for 800ms of inactivity before saving

            return () => {
                if (question.textSaveTimeout) {
                    clearTimeout(question.textSaveTimeout);
                }
            };
        }

        if (type === "option") {
            const isMultiSelect = question?.type === "multiple_choice_multi_select";

            // Calculate new value before state update
            const currentOptions = selectedOptions[questionId] || [];
            const newValue = isMultiSelect
                ? currentOptions.includes(option)
                    ? currentOptions.filter(opt => opt !== option)
                    : [...currentOptions, option]
                : [option];

            // Update local state
            setSelectedOptions(prevOptions => ({
                ...prevOptions,
                [questionId]: newValue
            }));

            // Make API call separately
            const data = {
                categoryId: categoryId,
                questionId: questionId,
                response: {
                    ...currentResponse,
                    value: isMultiSelect ? newValue : option,
                },
            };

            saveOnChange(id, _id, data, dispatch, page);
        }

        if (type === "comment") {
            setComment(prevState => ({
                ...prevState,
                [questionId]: e
            }));

            const timeoutId = setTimeout(() => {
                // Always send the value, even if empty
                const data = {
                    categoryId: categoryId,
                    questionId: questionId,
                    response: {
                        ...currentResponse,
                        comment: e,
                    },
                };
                saveOnChange(id, _id, data, dispatch, page);
            }, 800);

            return () => clearTimeout(timeoutId);
        }
    };

    const handleRouteChange = () => {
        history.push('/risk-management-dashboard-vendor');
    };

    const saveQuestionButton = (_id) => {
        saveQuestion(id, _id, data, handleRouteChange);
    }


    const closeModal = () => {
        setModal("");
    }

    const openModal = (qId, cId) => {
        setModal("Form Wizard modal risk");
        setCategoryId(cId);
        setQuestionId(qId);
    }

    const saveRisk = () => {
        if (registerFor == "") {
            toastr.error("Register For is required")
            return
        }
        if (riskLevel == "") {
            toastr.error("Risk Level is required")
            return
        }
        if (riskNote == "") {
            toastr.error("Risk Note is required")
            return
        }
        let data = {
            categoryId,
            questionId,
            riskNote,
            riskLevel,
            registerFor
        }
        addRiskRegister(id, _id, data, dispatch, closeModal)
    }

    const getProgressStatus = (category) => {
        if (!category?.categoryQuestions) return { completed: 0, total: 0 };
        const total = category.categoryQuestions.length;
        const completed = category.categoryQuestions.filter(q =>
            q.response?.value || q.response?.comment || (Array.isArray(q.response?.evidences) ? q.response?.evidences?.length > 0 : q.response?.evidences && typeof q.response?.evidences === 'object')
        ).length;
        return { completed, total };
    };


    const getOverallProgressStatus = () => {
        let totalQuestions = 0;
        let completedQuestions = 0;

        isModalData?.forEach(category => {
            if (category?.categoryQuestions) {
                totalQuestions += category.categoryQuestions.length;
                completedQuestions += category.categoryQuestions.filter(q =>
                    q.response?.value || q.response?.comment || (Array.isArray(q.response?.evidences) ? q.response?.evidences?.length > 0 : q.response?.evidences && typeof q.response?.evidences === 'object')
                ).length;
            }
        });

        return { completed: completedQuestions, total: totalQuestions };
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        // Update URL with new page
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('page', newPage);
        history.replace({
            pathname: window.location.pathname,
            search: searchParams.toString()
        });
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/risk-management-dashboard-vendor" className="welcome-textSmall">Questionnaires</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    Questionnaires Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="mb-4" style={{
                        backgroundColor: '#f8faff',
                        borderRadius: '10px',
                        padding: '20px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        border: '1px solid #e1e8ed'
                    }}>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        backgroundColor: '#6563ff',
                                        color: 'white',
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '15px',
                                        fontSize: '18px'
                                    }}>
                                        <i className="fa fa-list-alt"></i>
                                    </div>
                                    <div>
                                        <h6 style={{ color: '#666', margin: 0, fontSize: '13px' }}>Total Questions</h6>
                                        <h4 style={{ color: '#333', margin: 0, fontWeight: '600' }}>{totalItems}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        backgroundColor: '#ff9800',
                                        color: 'white',
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '15px',
                                        fontSize: '18px'
                                    }}>
                                        <i className="fa fa-clock-o"></i>
                                    </div>
                                    <div>
                                        <h6 style={{ color: '#666', margin: 0, fontSize: '13px' }}>Time Remaining</h6>
                                        <h4 style={{ color: '#333', margin: 0, fontWeight: '600' }}>
                                            {moment(showDetails?.dueDate).diff(moment(), 'days')} days
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex align-items-center justify-content-end h-100">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => setIsAiModalOpen(true)}
                                        disabled={aiLoading}
                                        style={{
                                            backgroundColor: '#6563ff',
                                            borderColor: '#6563ff',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 10px rgba(101, 99, 255, 0.15)',
                                            padding: '10px 20px',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '14px',
                                            minWidth: '120px',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {aiLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <span>Processing...</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-robot" style={{ fontSize: '16px'}}></i>
                                                <span style={{ fontSize: '14px' , color: '#fff'}}>Fill with AI</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Progress bar */}
                        <div style={{ marginTop: '20px' }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 style={{ margin: 0, color: '#666', fontSize: '13px' }}>Completion Progress</h6>
                                <span style={{ color: '#6563ff', fontWeight: '500' }}>
                                    {formStatus?.totalRespondedQuestions}/{formStatus?.totalQuestions} completed
                                </span>
                            </div>
                            <div style={{
                                height: '8px',
                                backgroundColor: '#e9ecef',
                                borderRadius: '4px',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    height: '100%',
                                    width: `${(formStatus?.totalRespondedQuestions / formStatus?.totalQuestions) * 100}%`,
                                    backgroundColor: '#6563ff',
                                    borderRadius: '4px',
                                    transition: 'width 0.3s ease'
                                }}></div>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive table-risk mt-3">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>Sender Name</th>
                                    <th>Due Date</th>
                                    <th>Questionnaire Forms</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {showDetails?.assignerOrganisationName || "N/A"}
                                    </td>
                                    <td>
                                        {moment(showDetails?.dueDate).format("DD-MM-YYYY") || "N/A"}
                                    </td>
                                    <td>
                                        {showDetails?.formTitle || "N/A"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <div className="group-box p-0 border-none">
                            <div>
                                <div className="d-flex">
                                    <div className="card" style={{
                                        width: chatData.length > 0 && !isChatMinimized ? 'w-70' : 'w-100',
                                        border: '1px solid #3d3c3c',
                                        transition: 'width 0.3s ease'
                                    }}>
                                        {isModalData?.map((category, catIndex) => (
                                            <Accordion key={catIndex} className="mb-0" defaultExpanded>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`panel${catIndex}-content`}
                                                    id={`panel${catIndex}-header`}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center w-100 mr-3">
                                                        <div>
                                                            <strong>{category?.categoryName}</strong>
                                                            <span className="boxButton ml-2" title="Number of questions in this category">
                                                                {category?.categoryQuestions?.length} Questions
                                                            </span>
                                                        </div>
                                                        <small style={{ color: '#9e9e9e' }}>
                                                            {getProgressStatus(category).completed}/{getProgressStatus(category).total} completed
                                                        </small>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="boxAccordian">
                                                        {category?.categoryQuestions?.map((question, qIndex) => (
                                                            <div key={qIndex} className="question-container" style={{
                                                                padding: '16px',
                                                                marginBottom: '16px',
                                                                border: '1px solid #e0e0e0',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                                backgroundColor: '#ffffff',
                                                                transition: 'all 0.3s ease'
                                                            }}>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <p style={{
                                                                        fontSize: '16px',
                                                                        fontWeight: '500',
                                                                        color: '#333',
                                                                        margin: '0'
                                                                    }}>
                                                                        {qIndex + 1}. {question?.question_text}
                                                                        {question?.response?.isAutoFilled && (
                                                                            <span style={{
                                                                                fontSize: '12px',
                                                                                backgroundColor: '#e6f7ff',
                                                                                color: '#1890ff',
                                                                                padding: '2px 8px',
                                                                                borderRadius: '4px',
                                                                                marginLeft: '8px',
                                                                                border: '1px solid #91d5ff',
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: '4px'
                                                                            }}>
                                                                                <i className="fa fa-history"></i>
                                                                                Previously Answered
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <button
                                                                            onClick={(event) => {
                                                                                chatOpenBox(category?.categoryName, question, category?.id, event);
                                                                            }}
                                                                            className="sqr-action-btn mr-2"
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                padding: '6px 12px',
                                                                                border: question.followupChatStats?.unseenMessages > 0 ? '2px solid #ff4d4f' : '1px solid #6563ff',
                                                                                borderRadius: '6px',
                                                                                background: question.followupChatStats?.unseenMessages > 0 ? '#fff1f0' : 'transparent',
                                                                                color: question.followupChatStats?.unseenMessages > 0 ? '#ff4d4f' : '#6563ff',
                                                                                cursor: 'pointer',
                                                                                transition: 'all 0.2s ease',
                                                                                position: 'relative',
                                                                                fontSize: '13px'
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-comment"></i>
                                                                            <span>Follow-up</span>
                                                                            {question.followupChatStats && (
                                                                                <>
                                                                                    {question.followupChatStats.totalMessages > 0 && !question.followupChatStats.unseenMessages && (
                                                                                        <span style={{
                                                                                            position: 'absolute',
                                                                                            top: '-8px',
                                                                                            right: '-8px',
                                                                                            backgroundColor: '#6563ff',
                                                                                            color: 'white',
                                                                                            borderRadius: '50%',
                                                                                            width: '20px',
                                                                                            height: '20px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: 'bold'
                                                                                        }}>
                                                                                            {question.followupChatStats.totalMessages}
                                                                                        </span>
                                                                                    )}
                                                                                    {question.followupChatStats?.unseenMessages > 0 && (
                                                                                        <span style={{
                                                                                            position: 'absolute',
                                                                                            top: '-8px',
                                                                                            right: '-8px',
                                                                                            backgroundColor: '#ff4d4f',
                                                                                            color: 'white',
                                                                                            borderRadius: '50%',
                                                                                            width: '20px',
                                                                                            height: '20px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: 'bold'
                                                                                        }}>
                                                                                            {question.followupChatStats.unseenMessages}
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </button>
                                                                        {/* <img src={humburger}
                                                                            onClick={(event) => {
                                                                                chatOpenBox(category?.categoryName, question, category?.id, event);
                                                                            }}
                                                                            className="img-fluid cursor" alt="Menu" /> */}
                                                                    </div>
                                                                </div>
                                                                {question?.evidence == true && (
                                                                    <label className="uploadDoc" style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        padding: '8px 16px',
                                                                        backgroundColor: '#f5f5f5',
                                                                        border: '1px dashed #6563ff',
                                                                        borderRadius: '6px',
                                                                        color: '#6563ff',
                                                                        cursor: 'pointer',
                                                                        marginTop: '12px',
                                                                        transition: 'all 0.2s ease',
                                                                        fontSize: '14px'
                                                                    }}>
                                                                        <input type="file"
                                                                            multiple
                                                                            onChange={(e) => {
                                                                                uploadImg(e, question, category?.id)
                                                                            }}
                                                                            className="d-none cursor" />
                                                                        <i className="fa fa-cloud-upload mr-2"></i> Upload Documents
                                                                        <img src={uploadDoc} className="img-fluid ml-2" alt="upload document icon" width="18" />
                                                                    </label>
                                                                )}

                                                                <div className="evidence-files" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                                                    {Array.isArray(question?.response?.evidences) ? 
                                                                        question?.response?.evidences?.map((r, idx) => {
                                                                            const filename = r?.fileName?.split('/')?.pop()?.split('-')?.slice(-1)[0] || r?.fileKey?.split('/')?.pop()?.split('-')?.slice(-1)[0] || 'Download File';
                                                                            return (
                                                                                <div key={idx} className="file-download-section" style={{
                                                                                    position: 'relative',
                                                                                    padding: '8px 12px',
                                                                                    backgroundColor: '#f0f7ff',
                                                                                    borderRadius: '6px',
                                                                                    border: '1px solid #e1e8ed',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    maxWidth: 'fit-content',
                                                                                    transition: 'all 0.2s ease'
                                                                                }}>
                                                                                    <a
                                                                                        href={r?.signedUrl}
                                                                                        target="_blank"
                                                                                        download={r?.signedUrl}
                                                                                        className="download-link"
                                                                                        style={{
                                                                                            color: '#2c65cf',
                                                                                            textDecoration: 'none',
                                                                                            fontWeight: '500',
                                                                                            fontSize: '14px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            gap: '6px'
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-file-o"></i> {filename}
                                                                                    </a>
                                                                                    <i
                                                                                        className="fa fa-times-circle"
                                                                                        onClick={() => removeFile(question, category?.id, r)}
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '-8px',
                                                                                            right: '-8px',
                                                                                            color: '#ff4d4f',
                                                                                            backgroundColor: 'white',
                                                                                            borderRadius: '50%',
                                                                                            cursor: 'pointer',
                                                                                            fontSize: '16px',
                                                                                            padding: '2px'
                                                                                        }}
                                                                                    ></i>
                                                                                </div>
                                                                            );
                                                                        }) : 
                                                                        // Handle case where evidences is an object (single file)
                                                                        question?.response?.evidences && typeof question?.response?.evidences === 'object' && !Array.isArray(question?.response?.evidences) ? 
                                                                            (() => {
                                                                                const r = question?.response?.evidences;
                                                                                const filename = r?.fileName?.split('/')?.pop()?.split('-')?.slice(-1)[0] || 'Download File';
                                                                                return (
                                                                                    <div key="single-evidence" className="file-download-section" style={{
                                                                                        position: 'relative',
                                                                                        padding: '8px 12px',
                                                                                        backgroundColor: '#f0f7ff',
                                                                                        borderRadius: '6px',
                                                                                        border: '1px solid #e1e8ed',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        maxWidth: 'fit-content',
                                                                                        transition: 'all 0.2s ease'
                                                                                    }}>
                                                                                        <a
                                                                                            href={r?.signedUrl}
                                                                                            target="_blank"
                                                                                            download={r?.signedUrl}
                                                                                            className="download-link"
                                                                                            style={{
                                                                                                color: '#2c65cf',
                                                                                                textDecoration: 'none',
                                                                                                fontWeight: '500',
                                                                                                fontSize: '14px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                gap: '6px'
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-file-o"></i> {filename}
                                                                                        </a>
                                                                                        <i
                                                                                            className="fa fa-times-circle"
                                                                                            onClick={() => removeFile(question, category?.id, r)}
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                top: '-8px',
                                                                                                right: '-8px',
                                                                                                color: '#ff4d4f',
                                                                                                backgroundColor: 'white',
                                                                                                borderRadius: '50%',
                                                                                                cursor: 'pointer',
                                                                                                fontSize: '16px',
                                                                                                padding: '2px'
                                                                                            }}
                                                                                        ></i>
                                                                                    </div>
                                                                                );
                                                                            })() : null
                                                                    }
                                                                </div>

                                                                <div className="mb-4">
                                                                    {question?.type === "text" ? (
                                                                        <div style={{ position: 'relative' }}>
                                                                            <textarea
                                                                                className="form-control"
                                                                                rows="4"
                                                                                placeholder="Enter your response here..."
                                                                                value={textarea[question.id] !== undefined ? textarea[question.id] : (question.response?.value || "")}
                                                                                style={{
                                                                                    border: question?.response?.isAutoFilled ? '1px solid #91d5ff' : '1px solid #e0e0e0',
                                                                                    borderRadius: '8px',
                                                                                    padding: '12px',
                                                                                    resize: 'vertical',
                                                                                    transition: 'border-color 0.3s ease',
                                                                                    marginTop: '12px',
                                                                                    boxShadow: question?.response?.isAutoFilled ? '0 0 0 2px rgba(24, 144, 255, 0.1)' : 'none',
                                                                                    fontSize: '14px',
                                                                                    backgroundColor: question?.response?.isAutoFilled ? '#f0f7ff' : '#ffffff'
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    const newValue = e.target.value;
                                                                                    // Update local state immediately for responsive UI
                                                                                    setTextArea(prev => ({
                                                                                        ...prev,
                                                                                        [question.id]: newValue
                                                                                    }));

                                                                                    // Use debounced saving
                                                                                    if (window.textareaTimeouts && window.textareaTimeouts[question.id]) {
                                                                                        clearTimeout(window.textareaTimeouts[question.id]);
                                                                                    }

                                                                                    // Initialize timeout storage if needed
                                                                                    if (!window.textareaTimeouts) {
                                                                                        window.textareaTimeouts = {};
                                                                                    }

                                                                                    // Set new timeout for this field
                                                                                    window.textareaTimeouts[question.id] = setTimeout(() => {
                                                                                        SelectInput(
                                                                                            newValue,
                                                                                            question,
                                                                                            "",
                                                                                            "text",
                                                                                            category?.id
                                                                                        );
                                                                                    }, 800);
                                                                                }}
                                                                            ></textarea>
                                                                        </div>
                                                                    ) : question?.options?.map((option, optIndex) => {
                                                                        const isSelected = selectedOptions[question.id]?.includes(option) || question.response?.value === option;
                                                                        return (
                                                                            <div
                                                                                key={optIndex}
                                                                                className={`option-item`}
                                                                                style={{
                                                                                    padding: '10px 16px',
                                                                                    margin: '8px 0',
                                                                                    borderRadius: '8px',
                                                                                    cursor: 'pointer',
                                                                                    transition: 'all 0.2s ease',
                                                                                    backgroundColor: isSelected ? (question?.response?.isAutoFilled ? '#e6f7ff' : '#ebf5ff') : '#f8f9fa',
                                                                                    border: isSelected ? (question?.response?.isAutoFilled ? '1px solid #91d5ff' : '1px solid #40a9ff') : '1px solid #e0e0e0',
                                                                                    color: isSelected ? (question?.response?.isAutoFilled ? '#1890ff' : '#1890ff') : '#333',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    fontWeight: isSelected ? '500' : 'normal',
                                                                                    width: 'fit-content',
                                                                                    minWidth: '200px',
                                                                                    position: 'relative'
                                                                                }}
                                                                                onClick={() =>
                                                                                    SelectInput(option, question, option, "option", category?.id)
                                                                                }
                                                                            >
                                                                                <div style={{
                                                                                    width: '18px',
                                                                                    height: '18px',
                                                                                    borderRadius: question?.type === "multiple_choice_multi_select" ? '4px' : '50%',
                                                                                    border: isSelected ? (question?.response?.isAutoFilled ? '2px solid #91d5ff' : '2px solid #1890ff') : '2px solid #d9d9d9',
                                                                                    marginRight: '12px',
                                                                                    position: 'relative',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    alignItems: 'center'
                                                                                }}>
                                                                                    {isSelected && (
                                                                                        <div style={{
                                                                                            width: '10px',
                                                                                            height: '10px',
                                                                                            borderRadius: question?.type === "multiple_choice_multi_select" ? '2px' : '50%',
                                                                                            backgroundColor: question?.response?.isAutoFilled ? '#91d5ff' : '#1890ff'
                                                                                        }}></div>
                                                                                    )}
                                                                                </div>
                                                                                {option}
                                                                                {isSelected && question?.response?.isAutoFilled && (
                                                                                    <span style={{
                                                                                        position: 'absolute',
                                                                                        right: '8px',
                                                                                        fontSize: '12px',
                                                                                        color: '#1890ff',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '4px'
                                                                                    }}>
                                                                                        <i className="fa fa-history"></i>
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                    {question?.showComment && (
                                                                        <div className="mt-3" style={{ position: 'relative' }}>
                                                                            <textarea
                                                                                className="form-control"
                                                                                rows="4"
                                                                                value={comment[question?.id] !== undefined ? comment[question?.id] : (question.response?.comment || "")}
                                                                                placeholder="Add a comment..."
                                                                                style={{
                                                                                    border: question?.response?.isAutoFilled ? '1px solid #91d5ff' : '1px solid #e0e0e0',
                                                                                    borderRadius: '8px',
                                                                                    padding: '12px',
                                                                                    resize: 'vertical',
                                                                                    transition: 'border-color 0.3s ease',
                                                                                    boxShadow: question?.response?.isAutoFilled ? '0 0 0 2px rgba(24, 144, 255, 0.1)' : 'none',
                                                                                    fontSize: '14px',
                                                                                    backgroundColor: question?.response?.isAutoFilled ? '#f0f7ff' : '#ffffff'
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    const newValue = e.target.value;
                                                                                    // Update local state immediately
                                                                                    setComment(prev => ({
                                                                                        ...prev,
                                                                                        [question?.id]: newValue
                                                                                    }));

                                                                                    // Show saving indicator
                                                                                    if (!window.savingStatus) window.savingStatus = {};
                                                                                    window.savingStatus[question.id] = true;

                                                                                    // Force re-render to show saving indicator
                                                                                    setSavingState(prev => ({ ...prev, [question.id]: true }));

                                                                                    // Use debounced saving for comments too
                                                                                    if (window.commentTimeouts && window.commentTimeouts[question.id]) {
                                                                                        clearTimeout(window.commentTimeouts[question.id]);
                                                                                    }

                                                                                    // Initialize timeout storage if needed
                                                                                    if (!window.commentTimeouts) {
                                                                                        window.commentTimeouts = {};
                                                                                    }

                                                                                    // Set new timeout for this field - always send the value even if empty
                                                                                    window.commentTimeouts[question.id] = setTimeout(() => {
                                                                                        SelectInput(
                                                                                            newValue,
                                                                                            question,
                                                                                            "",
                                                                                            "comment",
                                                                                            category?.id
                                                                                        );

                                                                                        // Clear saving indicator after save
                                                                                        if (window.savingStatus) window.savingStatus[question.id] = false;
                                                                                        setSavingState(prev => ({ ...prev, [question.id]: false }));
                                                                                    }, 800);
                                                                                }}
                                                                            ></textarea>

                                                                            {/* Saving indicator */}
                                                                            {savingState && savingState[question.id] && (
                                                                                <div
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        bottom: '12px',
                                                                                        right: '15px',
                                                                                        fontSize: '13px',
                                                                                        fontWeight: '500',
                                                                                        color: '#1890ff',
                                                                                        pointerEvents: 'none',
                                                                                        backgroundColor: '#ffffff',
                                                                                        padding: '4px 10px',
                                                                                        borderRadius: '4px',
                                                                                        border: '1px solid #91d5ff',
                                                                                        boxShadow: '0 2px 4px rgba(24, 144, 255, 0.15)',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '6px',
                                                                                        zIndex: 10
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-spinner fa-spin" style={{ fontSize: '12px' }}></i>
                                                                                    <span>Saving...</span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                        <div className="dataTables_paginate ml-2 d-flex justify-content-between align-items-center">
                                            {totalItems > 0 && (
                                                <Pagination
                                                    className="pagination-bar"
                                                    currentPage={page}
                                                    totalCount={totalItems}
                                                    pageSize={10}
                                                    onPageChange={handlePageChange}
                                                    totalPages={Math.ceil(totalItems / 10)}
                                                />
                                            )}
                                            {page === Math.ceil(totalItems / 10) && (
                                                <button
                                                    className="send-button mr-2 mb-2"
                                                    onClick={() => {
                                                        saveQuestionButton(showDetails?._id)
                                                    }}
                                                >
                                                    {getOverallProgressStatus().completed === getOverallProgressStatus().total &&
                                                        getOverallProgressStatus().total > 0
                                                        ? "Submit"
                                                        : "Save"}
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {chatData.length > 0 && (
                                        <div className={`chat-panel ${isChatMinimized ? 'minimized' : ''}`}
                                            style={{
                                                position: 'fixed',
                                                right: '20px',
                                                top: 'var(--chat-top-position)',
                                                width: isChatMinimized ? '250px' : '30%',
                                                maxWidth: '450px',
                                                minWidth: '250px',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '10px',
                                                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                                                transition: 'all 0.3s ease',
                                                zIndex: 1000,
                                                overflow: 'hidden'
                                            }}>
                                            <div className="chat-header"
                                                style={{
                                                    padding: '12px 16px',
                                                    borderBottom: '1px solid #e0e0e0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '10px 10px 0 0'
                                                }}
                                                onClick={() => {
                                                    const wasMinimized = isChatMinimized;
                                                    setIsChatMinimized(!isChatMinimized);

                                                    // If we're maximizing the chat that was previously minimized, scroll to the bottom
                                                    if (wasMinimized) {
                                                        setTimeout(() => {
                                                            const chatContainer = document.querySelector('.chatBoxMain');
                                                            if (chatContainer) {
                                                                chatContainer.scrollTop = chatContainer.scrollHeight;
                                                            }
                                                        }, 100);
                                                    }
                                                }}>
                                                <div className="d-flex align-items-center">
                                                    <span className="mr-2" style={{ fontSize: '18px', color: '#6563ff' }}>💬</span>
                                                    <span style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>
                                                        Question Discussion
                                                    </span>
                                                </div>
                                                <div>
                                                    {isChatMinimized ?
                                                        <i className="fa fa-chevron-up" style={{ fontSize: '12px', color: '#666' }}></i> :
                                                        <i className="fa fa-chevron-down" style={{ fontSize: '12px', color: '#666' }}></i>
                                                    }
                                                </div>
                                            </div>

                                            {!isChatMinimized && (
                                                <>
                                                    <div className="chatBoxMain chat-body"
                                                        style={{
                                                            height: '350px',
                                                            overflowY: 'auto',
                                                            padding: '16px',
                                                            backgroundColor: '#ffffff'
                                                        }}>
                                                        <div className="question-context"
                                                            style={{
                                                                backgroundColor: '#f0f7ff',
                                                                padding: '14px',
                                                                borderRadius: '8px',
                                                                marginBottom: '16px',
                                                                border: '1px solid #d7e3f7'
                                                            }}>
                                                            <p style={{ fontSize: '12px', color: '#5a7abf', marginBottom: '4px', fontWeight: 'bold' }}>
                                                                <i className="fa fa-question-circle mr-1"></i> Original Question:
                                                            </p>
                                                            <p className="mb-3" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                                                                {chatData[1]?.question_text}
                                                            </p>
                                                            <p style={{ fontSize: '12px', color: '#5a7abf', marginBottom: '4px', fontWeight: 'bold' }}>
                                                                <i className="fa fa-check-circle mr-1"></i> Current Answer:
                                                            </p>
                                                            <p style={{ fontSize: '14px', color: '#333' }}>
                                                                {chatData?.type === "text" ?
                                                                    chatData[1]?.response?.value :
                                                                    Array.isArray(chatData[1]?.response?.value) ?
                                                                        chatData[1]?.response?.value.join(', ') :
                                                                        chatData[1]?.response?.value || "No answer yet"}
                                                            </p>
                                                        </div>

                                                        <div className="chat-messages">
                                                            {messageAll?.map((message, index) => (
                                                                <div
                                                                    key={message?.id || message?.createdAt}
                                                                    className={`message ${message?.type === "sent" ? "message-sent" : "message-received"}`}
                                                                    style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: message?.type === "sent" ? 'flex-end' : 'flex-start',
                                                                        marginBottom: '16px'
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            backgroundColor: message?.type === "sent" ? '#6563ff' : '#f0f2f5',
                                                                            color: message?.type === "sent" ? '#fff' : '#333',
                                                                            padding: '12px 16px',
                                                                            borderRadius: '18px',
                                                                            maxWidth: '80%',
                                                                            wordBreak: 'break-word',
                                                                            boxShadow: message?.type === "sent" ?
                                                                                '0 2px 4px rgba(101, 99, 255, 0.25)' :
                                                                                '0 2px 4px rgba(0, 0, 0, 0.05)'
                                                                        }}
                                                                    >
                                                                        {message?.messageText}
                                                                    </div>

                                                                    {message?.attachedFiles && (
                                                                        <div
                                                                            style={{
                                                                                marginTop: '5px',
                                                                                maxWidth: '80%',
                                                                                backgroundColor: message?.type === "sent" ? '#5653e8' : '#e9eaed',
                                                                                borderRadius: '12px',
                                                                                padding: '8px',
                                                                                overflow: 'hidden',
                                                                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                                                                            }}
                                                                        >
                                                                            {message?.attachedFiles[0]?.fileType?.startsWith('image/') ? (
                                                                                <img
                                                                                    src={message?.attachedFiles[0]?.signedUrl}
                                                                                    style={{ maxWidth: '100%', borderRadius: '8px' }}
                                                                                    alt="chat attachment"
                                                                                />
                                                                            ) : (
                                                                                <div
                                                                                    style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        padding: '5px 10px',
                                                                                        color: message?.type === "sent" ? '#fff' : '#333'
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-file mr-2"></i>
                                                                                    <a
                                                                                        href={message?.attachedFiles[0]?.signedUrl}
                                                                                        target="_blank"
                                                                                        download={message?.attachedFiles[0]?.fileName}
                                                                                        style={{
                                                                                            color: message?.type === "sent" ? '#fff' : '#2c65cf',
                                                                                            textDecoration: 'underline'
                                                                                        }}
                                                                                    >
                                                                                        {message?.attachedFiles[0]?.fileName || 'Download File'}
                                                                                    </a>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <div
                                                                        style={{
                                                                            fontSize: '11px',
                                                                            color: '#aaa',
                                                                            marginTop: '4px',
                                                                            padding: '0 4px'
                                                                        }}
                                                                    >
                                                                        {moment(message?.createdAt).format("HH:mm")}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div className="chat-input"
                                                        style={{
                                                            borderTop: '1px solid #e0e0e0',
                                                            padding: '12px',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '0 0 10px 10px'
                                                        }}>
                                                        <div className="ReplyBox m-0">
                                                            <div className="input-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                                                                <input
                                                                    placeholder="Type a message..."
                                                                    value={messageInput}
                                                                    onKeyDown={(e) => e.key === 'Enter' && sendMessages()}
                                                                    onChange={(e) => setMessageInput(e.target.value)}
                                                                    className="form-control"
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        height: '40px',
                                                                        backgroundColor: '#ffffff',
                                                                        border: '1px solid #e0e0e0',
                                                                        color: '#333',
                                                                        borderRadius: '20px',
                                                                        paddingLeft: '16px',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                                                    }}
                                                                />
                                                                <div className="input-wrapper iconSend" style={{ marginLeft: '10px' }}>
                                                                    <FontAwesomeIcon
                                                                        icon={faFileUpload}
                                                                        onClick={() => fileInputRef.current?.click()}
                                                                        className="icon-attachment"
                                                                        style={{ marginRight: '12px', cursor: 'pointer', color: '#6563ff', fontSize: '16px' }}
                                                                    />
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    <img src={sendButtonImg}
                                                                        onClick={sendMessages}
                                                                        alt="Send message"
                                                                        style={{ cursor: 'pointer', width: '28px', height: '28px' }} />
                                                                </div>
                                                            </div>
                                                            {selectedFile && (
                                                                <div className="selected-file" style={{
                                                                    fontSize: '13px',
                                                                    padding: '6px 12px',
                                                                    marginTop: '8px',
                                                                    backgroundColor: '#f0f7ff',
                                                                    borderRadius: '6px',
                                                                    color: '#2c65cf',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    border: '1px solid #d7e3f7'
                                                                }}>
                                                                    <span><i className="fa fa-paperclip mr-1"></i> {selectedFile.name}</span>
                                                                    <button onClick={() => setSelectedFile(null)}
                                                                        style={{
                                                                            border: 'none',
                                                                            background: 'none',
                                                                            color: '#ff4d4f',
                                                                            padding: '0 4px',
                                                                            cursor: 'pointer',
                                                                            fontSize: '16px'
                                                                        }}>×</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal risk" ? "d-block show" : ""
                            }`}
                    >
                        <div className="modal-dialog modal-lg" id="clientModal">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Raise a risk
                                    </h5>
                                    <button
                                        type="button"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => setModal("")}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body pricing_page" style={{ height: 'auto' }}>
                                    <div className="col-xl-12 col-lg-12 col-md-12">
                                        <div className="card">
                                            <div className="row clearfix">
                                                <div className="form-group col-lg-12 col-md-12">
                                                    <label>
                                                        Risk Accepted
                                                    </label>
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm"
                                                        value={registerFor}
                                                        onChange={(e) => setRegisterFor(e.target.value)}
                                                    >
                                                        <option value="forever">Forever</option>
                                                        <option value="3 months">3 Months</option>
                                                        <option value="6 months">6 Months</option>
                                                        <option value="12 months">12 Months</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-12">
                                                    <label>Risk Type
                                                    </label>
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm"
                                                        value={riskLevel}
                                                        onChange={(e) => setRiskLevel(e.target.value)}
                                                    >
                                                        <option value="low">Low</option>
                                                        <option value="medium">Medium</option>
                                                        <option value="high">High</option>
                                                        <option value="critical">Critical</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-12">
                                                    <label>
                                                        Comment
                                                    </label>
                                                    <textarea
                                                        rows="3"
                                                        className="form-control"
                                                        value={riskNote}
                                                        onChange={(e) => setRiskNote(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-12" style={{ display: 'block', width: '100%', textAlign: 'end' }}>
                                                    <button className="send-button mr-2"
                                                        onClick={() => {
                                                            saveRisk()
                                                        }}>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isAiModalOpen ? "d-block show" : ""}`}
                style={{
                    backgroundColor: 'rgba(0,0,0,0.5)'
                }}
            >
                <div className="modal-dialog modal-lg" id="aiModal">
                    <div className="modal-content" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 5px 25px rgba(0,0,0,0.1)' }}>
                        <div className="modal-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0', padding: '16px 20px' }}>
                            <h5 className="modal-title" id="aiModalLabel" style={{ display: 'flex', alignItems: 'center', color: '#333' }}>
                                <span style={{ fontSize: '22px', marginRight: '10px' }}>🤖</span> Questionnaire AI
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setIsAiModalOpen(false)}
                                style={{ fontSize: '24px', color: '#666' }}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page" style={{ padding: '20px', backgroundColor: '#fff' }}>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="card mb-0" style={{ border: 'none', boxShadow: 'none' }}>
                                    <div className="card-body" style={{ padding: '10px 0' }}>
                                        <div style={{
                                            backgroundColor: '#f0f7ff',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            marginBottom: '20px',
                                            border: '1px solid #d7e3f7'
                                        }}>
                                            <p style={{ fontSize: '15px', color: '#333', marginBottom: '15px' }}>
                                                The AI will help you answer all questionnaire items automatically by analyzing:
                                            </p>
                                            <ul style={{ paddingLeft: '25px', marginBottom: '15px' }}>
                                                <li style={{ marginBottom: '8px', color: '#333' }}>Your organization's policies and procedures</li>
                                                <li style={{ marginBottom: '8px', color: '#333' }}>Industry standard compliance requirements</li>
                                                <li style={{ marginBottom: '8px', color: '#333' }}>Previous responses to similar questions</li>
                                            </ul>
                                            <p style={{ fontSize: '14px', color: '#666' }}>
                                                <i className="fa fa-info-circle mr-2"></i>
                                                This process may take a few moments. You can review and edit all AI-generated answers before final submission.
                                            </p>
                                        </div>

                                        <div className="text-center">
                                            <button
                                                className="btn btn-primary btn-lg"
                                                onClick={handleAIQuestionnaireSubmit}
                                                disabled={aiLoading}
                                                style={{
                                                    backgroundColor: '#6563ff',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '12px 30px',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    boxShadow: '0 4px 10px rgba(101, 99, 255, 0.25)',
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                {aiLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                        Processing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa fa-robot mr-2"></i> Submit to AI
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Minimized Chat Button */}
            {chatData.length > 0 && isChatMinimized && (
                <div
                    className="minimized-chat-button"
                    onClick={() => {
                        setIsChatMinimized(false);
                        // Scroll to the bottom after a short delay to ensure the chat container is rendered
                        setTimeout(() => {
                            const chatContainer = document.querySelector('.chatBoxMain');
                            if (chatContainer) {
                                chatContainer.scrollTop = chatContainer.scrollHeight;
                            }
                        }, 100);
                    }}
                    style={{
                        position: 'fixed',
                        right: '20px',
                        top: 'var(--chat-top-position)',
                        backgroundColor: '#6563ff',
                        color: 'white',
                        padding: '10px 15px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        boxShadow: '0 2px 8px rgba(101, 99, 255, 0.25)',
                        zIndex: 1000,
                        transition: 'all 0.3s ease'
                    }}
                >
                    <span style={{ fontSize: '16px' }}>💬</span>
                    <span>Show Chat</span>
                </div>
            )}
        </div>
    );
};

export default ShowDetailsVendorQuestionnaires;



